module.exports = __webpack_public_path__ + "img/789.775cd2a5.gif";